import {
  createDefaultReadmissionPayload,
  UseNotePayload,
  useNotePayload,
} from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f";
import { INITIAL_F2F_EXTRA_DEFAULTS } from "../initial-f2f-constant";
import { InitialF2fPayload } from "../initial-f2f-types";

const createDefaultPayload = (): InitialF2fPayload => ({
  ...createDefaultReadmissionPayload(),
  ...INITIAL_F2F_EXTRA_DEFAULTS,
});

export type UseInitialF2fNote = UseNotePayload<InitialF2fPayload>;

export const useInitialF2fNote = (
  initial: InitialF2fPayload | undefined,
  sectionKeys: string[]
): UseInitialF2fNote =>
  useNotePayload<InitialF2fPayload>(
    () => initial ?? createDefaultPayload(),
    sectionKeys
  );
